{
	"environments": [
		"production",
		"staging",
		"demo",
		"development"
	],
	"demoEnvironments": ["jade", "teal", "noir", "plum", "vert", "cyan", "opal", "orion"]
}
